import { defineNuxtPlugin } from '#app/nuxt'
import { sanitizeHtml } from '@/utils/sanitize'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('safe-html', {
    getSSRProps(binding) {
      return {
        innerHTML: sanitizeHtml(binding.value),
      }
    },
    mounted(el, binding) {
      el.innerHTML = sanitizeHtml(binding.value)
    },
    updated(el, binding) {
      el.innerHTML = sanitizeHtml(binding.value)
    },
  })
})
